// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lead {
  font-weight: 400;
}

.delete-group {
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
}

.look-disabled {
  opacity: 0.38;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/components/add-edit-group-modal-v2/add-edit-group-modal-v2.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/dashboard/components/add-edit-group-modal-v2/add-edit-group-modal-v2.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;ACCF;;ADEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF","sourcesContent":[".lead {\r\n  font-weight: 400;\r\n}\r\n\r\n.delete-group {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  cursor: pointer;\r\n}\r\n\r\n.look-disabled {\r\n  opacity: 0.38;\r\n  cursor: not-allowed;\r\n}\r\n",".lead {\n  font-weight: 400;\n}\n\n.delete-group {\n  font-size: 16px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.look-disabled {\n  opacity: 0.38;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
